import type { NomadDB } from '~/db/NomadDB';
import { getServices } from '~/db/services';

const _retrieveMediaIdsFromPopulateCategory = (
  data: Array<CategorySchema> | Array<PostSchema>,
  acc = []
): Array<string> => {
  data.forEach((item) => {
    if (item.mediaIcon) {
      acc.push(item.mediaIcon);
    }
    if (item.medias) {
      acc = [...acc, ...item.medias.map((item) => item.id)];
    }

    if (item.posts) {
      acc = [..._retrieveMediaIdsFromPopulateCategory(item.posts, acc)];
    }
    if (item.children) {
      acc = [..._retrieveMediaIdsFromPopulateCategory(item.children, acc)];
    }
  });
  return acc;
};

export const retrieveMediaIdsFromPopulateCategory = (
  data: CategorySchema | CategorySchema[]
): string[] => {
  data = !Array.isArray(data) ? [data] : data;
  const mediaIds = _retrieveMediaIdsFromPopulateCategory(data);
  return mediaIds;
};

export const retrieveMediaMapFromIds = async (
  $db: NomadDB,
  mediaIds: string[]
): Promise<Map<string, MediaSchema>> => {
  const { mediasService } = getServices($db);
  const media = await mediasService.findByIdsTransaction(mediaIds);

  const mediaMap = media.reduce(
    (acc: Map<string, MediaSchema>, cur: MediaSchema) => {
      acc.set(cur.id, cur);
      return acc;
    },
    new Map<string, MediaSchema>()
  );
  return mediaMap;
};
